(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artmypet-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-artmypet-home]');
    roots.forEach((root) => {
      const styleButtons = root.querySelectorAll('[data-style-note]');
      const styleNote = root.querySelector('[data-style-note-output]');

      styleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          styleButtons.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          if (styleNote) {
            styleNote.textContent = button.dataset.styleNote || '';
          }
        });
      });

      const stickyCta = root.querySelector('.amp-home__mobile-sticky');
      const updateStickyCta = () => {
        if (!stickyCta) return;
        stickyCta.classList.toggle('is-visible', window.innerWidth < 880 && window.scrollY > 520);
      };
      updateStickyCta();
      window.addEventListener('scroll', updateStickyCta, { passive: true });
      window.addEventListener('resize', updateStickyCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-portrait-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pet-portrait-hero]');
    if (!roots.length) return;
    document.body.classList.add('amp-has-mobile-cart');

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const money = (cents, currency) => {
      const amount = Number(cents || 0) / 100;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 0
      }).format(amount);
    };

    const variantValues = (variant) => variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
    const optionValue = (variant, optionName, optionNames) => {
      const names = optionNames || [];
      const values = variantValues(variant);
      const index = names.findIndex((name) => normalize(name) === normalize(optionName));
      return index >= 0 ? values[index] : '';
    };
    const isDigitalVariant = (variant) => {
      if (!variant) return false;
      return variant.sku === 'PP-DIGITAL' || variantValues(variant).some((value) => normalize(value).includes('digital'));
    };

    roots.forEach((root) => {
      const configEl = root.querySelector('[data-pet-portrait-config]');
      if (!configEl) return;
      const config = JSON.parse(configEl.textContent);
      const uploadText = config.uploadText || {};
      const text = (key, fallback) => uploadText[key] || fallback;
      const selectedVariant = config.variants.find((variant) => String(variant.id) === String(config.selectedVariantId)) ||
        config.variants.find((variant) => variant.sku === 'PP-BLACK-S1218') ||
        config.variants[0];
      const selectedIsDigital = isDigitalVariant(selectedVariant);
      const selectedSize = selectedIsDigital ? '12 x 18 inch' : optionValue(selectedVariant, 'Size', config.optionNames) || '12 x 18 inch';
      const selectedStyle = selectedIsDigital ? 'Digital File' : optionValue(selectedVariant, 'Style', config.optionNames) || 'Black Frame';
      const state = {
        artStyle: '',
        style: selectedStyle,
        size: selectedSize,
        lastPhysicalSize: selectedIsDigital ? '12 x 18 inch' : selectedSize,
        pets: 1,
        rush: false,
        uploadLater: true,
        uploadedUrls: []
      };

      const els = {
        mainImage: root.querySelector('.amp-hero__image'),
        thumbs: root.querySelectorAll('.amp-hero__thumb'),
        artStyleButtons: root.querySelectorAll('[data-art-style-option]'),
        artStyleGroup: root.querySelector('[data-art-style-group]'),
        artStyleNote: root.querySelector('[data-art-style-note-output]'),
        styleButtons: root.querySelectorAll('[data-style-option]'),
        sizeButtons: root.querySelectorAll('[data-size-option]'),
        sizeGroup: root.querySelector('[data-size-group]'),
        petButtons: root.querySelectorAll('[data-pet-count]'),
        rushToggle: root.querySelector('[data-rush-toggle]'),
        uploadLater: root.querySelector('[data-upload-later]'),
        fileInput: root.querySelector('[data-file-input]'),
        fileLabel: root.querySelector('[data-file-label]'),
        uploadList: root.querySelector('[data-upload-list]'),
        uploadStatus: root.querySelector('[data-upload-status]'),
        uploadProgress: root.querySelector('[data-upload-progress]'),
        variantInput: root.querySelector('[data-variant-id-input]'),
        propertyArtStyle: root.querySelector('[data-property-art-style]'),
        propertyPets: root.querySelector('[data-property-pets]'),
        propertyUpload: root.querySelector('[data-property-upload]'),
        photoProperties: root.querySelector('[data-photo-properties]'),
        form: root.querySelector('form[data-type="add-to-cart-form"]'),
        formErrorWrap: root.querySelector('.product-form__error-message-wrapper'),
        formError: root.querySelector('[data-form-error]'),
        submit: root.querySelector('[type="submit"]'),
        price: root.querySelector('[data-variant-price]'),
        compare: root.querySelector('[data-variant-compare]'),
        summaryArtStyle: root.querySelector('[data-summary-art-style]'),
        summaryFormat: root.querySelector('[data-summary-format]'),
        summarySize: root.querySelector('[data-summary-size]'),
        summarySizeRow: root.querySelector('[data-summary-size-row]'),
        summaryPets: root.querySelector('[data-summary-pets]'),
        summaryExtraRow: root.querySelector('[data-summary-extra-row]'),
        summaryExtraPets: root.querySelector('[data-summary-extra-pets]'),
        summaryRushRow: root.querySelector('[data-summary-rush-row]'),
        summaryTotal: root.querySelector('[data-summary-total]'),
        deliveryCopy: root.querySelector('[data-delivery-copy]'),
        mobileAdd: root.querySelector('[data-mobile-add]'),
        mobileTotal: root.querySelector('[data-mobile-total]')
      };

      if (state.uploadLater) {
        els.uploadLater.checked = true;
        els.uploadStatus.textContent = text('uploadLaterStatus', 'No problem. We will collect your photo after checkout.');
      }

      const findVariant = () => {
        if (state.style === 'Digital File') {
          return config.variants.find((variant) => variant.sku === 'PP-DIGITAL') ||
            config.variants.find((variant) => isDigitalVariant(variant));
        }
        return config.variants.find((variant) => {
          const values = variantValues(variant).map(normalize);
          return values.includes(normalize(state.style)) && values.includes(normalize(state.size));
        });
      };

      const variantAvailableFor = (style, size) => {
        if (style === 'Digital File') return config.variants.some((variant) => isDigitalVariant(variant));
        return config.variants.some((variant) => {
          const values = variantValues(variant).map(normalize);
          return values.includes(normalize(style)) && values.includes(normalize(size));
        });
      };

      const setPressed = (buttons, activeValue, attr) => {
        buttons.forEach((button) => {
          const active = button.getAttribute(attr) === activeValue;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const updatePhotoProperties = () => {
        els.photoProperties.innerHTML = '';
        state.uploadedUrls.slice(0, 4).forEach((url, index) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[_pet_photo_${index + 1}]`;
          input.value = url;
          els.photoProperties.append(input);
        });
        els.propertyUpload.value = state.uploadLater ? 'pending' : '';
      };

      const showError = (message) => {
        if (!els.formErrorWrap || !els.formError) return;
        els.formError.textContent = message || '';
        els.formErrorWrap.hidden = !message;
      };

      const refresh = () => {
        const variant = findVariant() || config.variants[0];
        if (!variant) return;
        const isDigital = state.style === 'Digital File' || isDigitalVariant(variant);
        const currentStyle = isDigital ? 'Digital File' : optionValue(variant, 'Style', config.optionNames) || state.style;
        const currentSize = optionValue(variant, 'Size', config.optionNames) || state.size;
        const extraPetTotal = Math.max(0, state.pets - 1) * 1500;
        const rushTotal = state.rush ? 1500 : 0;
        const total = Number(variant.price || 0) + extraPetTotal + rushTotal;

        els.variantInput.value = variant.id;
        els.propertyArtStyle.value = state.artStyle;
        els.propertyPets.value = String(state.pets);
        els.price.textContent = money(variant.price, config.currency);
        if (Number(variant.compare_at_price || 0) > Number(variant.price || 0)) {
          els.compare.hidden = false;
          els.compare.textContent = money(variant.compare_at_price, config.currency);
        } else {
          els.compare.hidden = true;
        }
        els.summaryArtStyle.textContent = state.artStyle || 'Not selected';
        els.summaryFormat.textContent = currentStyle;
        els.summaryPets.textContent = String(state.pets);
        els.summaryExtraRow.hidden = state.pets <= 1;
        els.summaryExtraPets.textContent = `${state.pets - 1} x ${money(1500, config.currency)}`;
        els.summaryRushRow.hidden = !state.rush;
        els.summaryTotal.textContent = money(total, config.currency);
        if (els.mobileTotal) els.mobileTotal.textContent = money(total, config.currency);
        els.sizeGroup.hidden = isDigital;
        els.summarySizeRow.hidden = isDigital;
        els.summarySize.textContent = isDigital ? '' : currentSize;
        els.deliveryCopy.textContent = isDigital
          ? 'High-resolution file (print-ready) delivered by email after proof approval.'
          : 'Printed, framed, and shipped domestically. 20 x 30 and 24 x 36 ship to the contiguous US only.';

        setPressed(els.artStyleButtons, state.artStyle, 'data-art-style-option');
        setPressed(els.styleButtons, state.style, 'data-style-option');
        setPressed(els.sizeButtons, state.size, 'data-size-option');
        setPressed(els.petButtons, String(state.pets), 'data-pet-count');

        els.sizeButtons.forEach((button) => {
          const available = variantAvailableFor(state.style, button.dataset.sizeOption);
          button.classList.toggle('is-unavailable', !available);
          button.disabled = !available;
        });

        updatePhotoProperties();
      };

      const uploadFile = async (file) => {
        if (!config.uploadEndpoint) {
          throw new Error(text('uploadNotConfigured', 'Photo upload is not configured yet. Choose Upload later to place the order now.'));
        }
        const signResponse = await fetch(config.uploadEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ filename: file.name, contentType: file.type, size: file.size })
        });
        if (!signResponse.ok) throw new Error(text('prepareFailed', 'Could not prepare upload. Please try again.'));
        const signed = await signResponse.json();
        const uploadUrl = signed.uploadUrl || signed.url;
        const fileUrl = signed.fileUrl || signed.publicUrl;
        if (!uploadUrl || !fileUrl) throw new Error(text('responseMissing', 'Upload response is missing a file URL.'));
        const putResponse = await fetch(uploadUrl, { method: 'PUT', body: file, headers: { 'Content-Type': file.type || 'application/octet-stream' } });
        if (!putResponse.ok) throw new Error(text('uploadFailed', 'Upload failed. Please try again.'));
        return fileUrl;
      };

      const inspectResolution = (file, previewUrl) => new Promise((resolve) => {
        if (!previewUrl || !file.type || !file.type.startsWith('image/') || file.type.toLowerCase().includes('heic')) {
          resolve('');
          return;
        }
        const image = new Image();
        image.onload = () => {
          const shortEdge = Math.min(image.naturalWidth || 0, image.naturalHeight || 0);
          resolve(shortEdge > 0 && shortEdge < 1000 ? text('lowResolution', 'Short edge is under 1000px. You can continue, but a larger photo may create a better proof.') : '');
        };
        image.onerror = () => resolve('');
        image.src = previewUrl;
      });

      const handleFiles = async (files) => {
        const selected = Array.from(files || []).slice(0, 4);
        const entries = [];
        state.uploadedUrls = [];
        els.uploadList.innerHTML = '';
        els.fileLabel.textContent = selected.length ? text('selected', '{count} selected').replace('{count}', selected.length) : text('noFileChosen', 'No file chosen');
        if (!selected.length) {
          refresh();
          return;
        }
        els.uploadProgress.hidden = false;
        els.uploadProgress.querySelector('span').style.width = '8%';

        const activeEntries = () => entries.filter((entry) => !entry.removed);
        const updateFileLabel = () => {
          const count = activeEntries().length;
          els.fileLabel.textContent = count ? text('selected', '{count} selected').replace('{count}', count) : text('noFileChosen', 'No file chosen');
        };
        const updateProgress = () => {
          const active = activeEntries();
          const complete = active.filter((entry) => entry.complete).length;
          els.uploadProgress.querySelector('span').style.width = active.length ? `${Math.max(12, Math.round(complete / active.length * 100))}%` : '0';
        };
        const removeEntry = (entry) => {
          entry.removed = true;
          if (entry.previewUrl) URL.revokeObjectURL(entry.previewUrl);
          if (entry.url) state.uploadedUrls = state.uploadedUrls.filter((url) => url !== entry.url);
          entry.item.remove();
          updateFileLabel();
          updateProgress();
          refresh();
        };
        const uploadEntry = async (entry) => {
          entry.complete = false;
          entry.retry.hidden = true;
          entry.state.textContent = text('waiting', 'Waiting');
          entry.warning.textContent = '';
          if (entry.file.size > config.maxFileBytes) {
            entry.complete = true;
            entry.state.textContent = text('notUploaded', 'Not uploaded');
            entry.warning.textContent = text('overSize', '{filename} is over 25MB.').replace('{filename}', entry.file.name);
            updateProgress();
            return;
          }
          entry.warning.textContent = await inspectResolution(entry.file, entry.previewUrl);
          try {
            const url = await uploadFile(entry.file);
            if (entry.removed) return;
            entry.url = url;
            state.uploadedUrls.push(url);
            entry.state.textContent = text('uploaded', 'Uploaded');
          } catch (error) {
            if (entry.removed) return;
            entry.state.textContent = text('notUploaded', 'Not uploaded');
            entry.retry.hidden = false;
            els.uploadStatus.textContent = error.message;
          } finally {
            entry.complete = true;
            updateProgress();
            refresh();
          }
        };

        for (const file of selected) {
          const previewUrl = file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : '';
          const item = document.createElement('div');
          item.className = 'amp-upload__file';
          const thumb = document.createElement('img');
          thumb.className = 'amp-upload__thumb';
          thumb.alt = '';
          if (previewUrl) thumb.src = previewUrl;
          const meta = document.createElement('div');
          meta.className = 'amp-upload__meta';
          const name = document.createElement('span');
          name.className = 'amp-upload__name';
          name.textContent = file.name;
          const stateLabel = document.createElement('span');
          stateLabel.className = 'amp-upload__state';
          stateLabel.textContent = text('waiting', 'Waiting');
          const warning = document.createElement('span');
          warning.className = 'amp-upload__warning';
          meta.append(name, stateLabel, warning);
          const actions = document.createElement('div');
          actions.className = 'amp-upload__actions';
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'amp-upload__action';
          retry.textContent = text('retry', 'Retry');
          retry.hidden = true;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'amp-upload__action';
          remove.textContent = text('remove', 'Remove');
          actions.append(retry, remove);
          item.append(thumb, meta, actions);
          els.uploadList.append(item);
          const entry = { file, item, state: stateLabel, warning, retry, previewUrl, url: '', removed: false, complete: false };
          retry.addEventListener('click', () => uploadEntry(entry));
          remove.addEventListener('click', () => removeEntry(entry));
          entries.push(entry);
          uploadEntry(entry);
        }
        await Promise.all(entries.map((entry) => new Promise((resolve) => {
          const check = () => entry.complete || entry.removed ? resolve() : setTimeout(check, 100);
          check();
        })));
        if (activeEntries().length === 0) {
          els.uploadProgress.hidden = true;
        }
        if (state.uploadedUrls.length) {
          els.uploadStatus.textContent = text('uploadComplete', 'Photo uploaded. We will use the original file for your proof.');
        }
        refresh();
      };

      els.thumbs.forEach((button) => {
        button.addEventListener('click', () => {
          if (!els.mainImage) return;
          els.mainImage.src = button.dataset.gallerySrc;
          els.mainImage.alt = button.dataset.galleryAlt || '';
          els.thumbs.forEach((thumb) => {
            const active = thumb === button;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      els.artStyleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          state.artStyle = button.dataset.artStyleOption;
          if (els.artStyleNote) {
            els.artStyleNote.textContent = button.dataset.artStyleNote || `${state.artStyle} selected.`;
          }
          showError('');
          refresh();
        });
      });

      els.styleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          state.style = button.dataset.styleOption;
          if (state.style === 'Digital File') {
            state.lastPhysicalSize = state.size;
          } else {
            state.size = state.lastPhysicalSize || '12 x 18 inch';
          }
          refresh();
        });
      });

      els.sizeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          state.size = button.dataset.sizeOption;
          state.lastPhysicalSize = state.size;
          refresh();
        });
      });

      els.petButtons.forEach((button) => {
        button.addEventListener('click', () => {
          state.pets = Math.min(4, Math.max(1, Number(button.dataset.petCount)));
          refresh();
        });
      });

      els.rushToggle.addEventListener('change', () => {
        state.rush = els.rushToggle.checked;
        refresh();
      });

      els.uploadLater.addEventListener('change', () => {
        state.uploadLater = els.uploadLater.checked;
        if (state.uploadLater) {
          state.uploadedUrls = [];
          els.fileInput.value = '';
          els.fileLabel.textContent = text('noFileChosen', 'No file chosen');
          els.uploadList.innerHTML = '';
          els.uploadStatus.textContent = text('uploadLaterStatus', 'No problem. We will collect your photo after checkout.');
        } else {
          els.uploadStatus.textContent = text('uploadHelp', 'One clear front-facing photo works best. Good lighting helps the artist create a better proof.');
        }
        refresh();
      });

      els.fileInput.addEventListener('change', () => {
        state.uploadLater = false;
        els.uploadLater.checked = false;
        handleFiles(els.fileInput.files);
      });

      if (els.mobileAdd) {
        els.mobileAdd.addEventListener('click', () => {
          if (els.mobileAdd.getAttribute('aria-disabled') === 'true') return;
          if (typeof els.form.requestSubmit === 'function') {
            els.form.requestSubmit(els.submit);
          } else {
            els.submit.click();
          }
        });
      }

      els.form.addEventListener('submit', async (event) => {
        event.preventDefault();
        showError('');
        if (!state.artStyle) {
          showError('Choose a portrait style before adding your portrait to the cart.');
          els.artStyleGroup?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          els.artStyleButtons[0]?.focus();
          return;
        }
        const variant = findVariant();
        if (!variant) {
          showError(text('optionUnavailable', 'This option is unavailable.'));
          return;
        }
        if (!state.uploadedUrls.length && !state.uploadLater) {
          state.uploadLater = true;
          els.uploadLater.checked = true;
          els.uploadStatus.textContent = text('uploadLaterStatus', 'No problem. We will collect your photo after checkout.');
          refresh();
        }
        if (state.pets > 1 && !config.extraPetVariantId) {
          showError(text('extraPetMissing', 'Extra pet add-on is not configured.'));
          return;
        }
        if (state.rush && !config.rushVariantId) {
          showError(text('rushMissing', 'Rush service is not configured.'));
          return;
        }

        const group = `portrait-${Date.now()}`;
        const properties = {
          'Portrait style': state.artStyle,
          'Number of pets': String(state.pets),
          '_bundle_group': group
        };
        if (state.uploadLater) {
          properties['_photo_upload'] = 'pending';
        } else {
          state.uploadedUrls.slice(0, 4).forEach((url, index) => {
            properties[`_pet_photo_${index + 1}`] = url;
          });
        }

        const items = [{ id: Number(variant.id), quantity: 1, properties }];
        if (state.pets > 1) {
          items.push({
            id: Number(config.extraPetVariantId),
            quantity: state.pets - 1,
            properties: { '_linked_to': group, '_addon': 'extra_pet' }
          });
        }
        if (state.rush) {
          items.push({
            id: Number(config.rushVariantId),
            quantity: 1,
            properties: { '_linked_to': group, '_addon': 'rush_service' }
          });
        }

        els.submit.setAttribute('aria-disabled', 'true');
        els.submit.classList.add('loading');
        els.mobileAdd?.setAttribute('aria-disabled', 'true');
        const spinner = els.submit.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        try {
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          });
          const parsed = await response.json();
          if (!response.ok || parsed.status) throw new Error(parsed.description || parsed.message || text('addFailed', 'Could not add this item.'));
          if (!parsed.key && Array.isArray(parsed.items) && parsed.items.length) {
            parsed.key = parsed.items[0].key;
          }
          if (cart && typeof cart.renderContents === 'function' && parsed.sections) {
            cart.renderContents(parsed);
          } else {
            window.location.href = routes.cart_url;
          }
        } catch (error) {
          showError(error.message || text('addFailed', 'Could not add this item.'));
        } finally {
          els.submit.classList.remove('loading');
          els.submit.removeAttribute('aria-disabled');
          els.mobileAdd?.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      });

      refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
